import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            大家都在讨论的国产影视话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              {topic.name}
              {topic.hot && (
                <span className="text-xs text-accent-500">热门</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}